import { PpeDocument } from '@/types/index';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export const ppeAnalysisService = {
  async uploadDocument(propertyId: string, file: File): Promise<PpeDocument> {
    const formData = new FormData();
    formData.append('file', file);

    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE}/ppe-analysis/upload/${propertyId}`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.message || 'Upload failed');
    }
    const data = await response.json();
    return data.data as PpeDocument;
  },

  async listDocuments(propertyId: string): Promise<PpeDocument[]> {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE}/ppe-analysis/documents/${propertyId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to list documents');
    const data = await response.json();
    return data.data as PpeDocument[];
  },

  async openDocument(docId: string): Promise<string> {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE}/ppe-analysis/documents/${docId}/view`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to fetch document');
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  },

  async deleteDocument(docId: string): Promise<void> {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE}/ppe-analysis/documents/${docId}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to delete document');
  },
};
